function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { useConfigService } from '@thd-nucleus/experience-context';

/**
 * Note: this is a short term solution to handle dynamic placement of components based on feature flags.
 * This is not a long term solution and should be replaced with a more robust solution using withConfigService.
 * Story to track this: https://thd.atlassian.net/browse/FUS1-310
 */

/**
 *
 * render: [
 *   {
 *     name: The feature switch name.
 *     value: The expected value to match against.
 *     default: The default slot if the feature switch is not found.
 *   }
 * ],
 *
 */
export function withConfigServiceTNT(BaseComponent) {
  let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  function ConfigServiceTNTRule(props) {
    var _opts$render;
    const {
      renderRules: renderRulesProp = [],
      propRules: propRulesProp = {}
    } = props;
    const configValue = useConfigService(opts === null || opts === void 0 ? void 0 : (_opts$render = opts.render) === null || _opts$render === void 0 ? void 0 : _opts$render.name);
    const renderRules = [...renderRulesProp];
    const propRules = _objectSpread({}, propRulesProp);
    if (opts.render) {
      if (configValue === undefined) {
        renderRules.push(!!opts.render.default);
      } else {
        const matchedValue = configValue === opts.render.value;
        renderRules.push(matchedValue);
      }
    }
    return /*#__PURE__*/React.createElement(BaseComponent, _extends({}, props, {
      renderRules: renderRules,
      propRules: propRules
    }));
  }
  ConfigServiceTNTRule.displayName = 'ConfigServiceTNTRule';
  ConfigServiceTNTRule.dataModel = {};
  return ConfigServiceTNTRule;
}
//# sourceMappingURL=withConfigServiceTNT.js.map